import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	profileData: {},
	positionId: null,
	unreadMessageCount: 0,
	delegatorUserIds: [],
	delegateeUserIds: [],
	isProfileUpdate: false,
	// unreadCompletedMessageCount: 0,
	// unreadOpenMessageCount: 0,
};

// ==============================|| SLICE - PROFILE ||============================== //

const profileSlice = createSlice({
	name: 'profile',
	initialState,
	reducers: {
		userProfileUpdate(state) {
			state.isProfileUpdate = !state.isProfileUpdate;
		},
		getUserProfile(state, action) {
			state.profileData = action.payload.profile;
		},
		setMessageNotification(state, action) {
			state.unreadMessageCount = action.payload.unreadMessageCount;
			// state.unreadOpenMessageCount = action.payload.unreadOpenMessageCount;
			// state.unreadCompletedMessageCount = action.payload.unreadCompletedMessageCount;
		},
		setDelegationSummary(state, action) {
			state.delegatorUserIds = action.payload.delegatorUserIds || [];
			state.delegateeUserIds = action.payload.delegateeUserIds || [];
		},
		setMarkAsRead(state, action) {
			if (action.payload.type === 'TOTAL') {
				state.unreadMessageCount = 0;
			}
			// else if (action.payload.type === 'OPEN') {
			//   state.unreadOpenMessageCount = 0;
			// } else if (action.payload.type === 'COMPLETE') {
			//   state.unreadCompletedMessageCount = 0;
			// }
		},
		resetProfile(state) {
			state.profileData = {};
			state.unreadMessageCount = 0;
			state.delegatorUserIds = [];
			state.delegateeUserIds = [];
			state.positionId = null;
		},
		setPositionId(state, action) {
			state.positionId = action.payload;
		},
	},
});

export const { getUserProfile, userProfileUpdate, setMessageNotification, setDelegationSummary, setMarkAsRead, resetProfile, setPositionId } = profileSlice.actions;
export default profileSlice.reducer;
